import React from "react";

import { OrderDetails } from "components/Orders/OrderDetails";

const OrderDetailsPage = () => {
  return <OrderDetails />;
};
export default OrderDetailsPage;
